import Button from '.';

/** @type {UICore.ComponentMeta} */
const ButtonComponentMeta = {
  id: 'w-button',
  name: '简单按钮',
  icon: 'https://vfiles.gtimg.cn/wuji_dashboard/xy/rainbow/icon-button_1636362804816.png',
  category: '按钮',
  display: 'inline',
  component: Button,
  propsSchema: {
    type: 'object',
    fields: [{
      id: 'title',
      type: 'string',
      title: '内容',
      default: '文案'
    }, {
      id: 'icon',
      type: 'string',
      title: '符号',
      default: '',
      ui: {
        type: 'iconSelectorInput'
      }
    }, {
      id: 'disabled',
      type: 'boolean',
      title: '禁用',
      default: false
    }, {
      id: 'loading',
      type: 'boolean',
      title: '载入中',
      default: false
    }, {
      id: 'type',
      type: 'string',
      title: '风格',
      enum: [{
        label: '普通',
        value: 'normal'
      }, {
        label: '主要',
        value: 'primary'
      }, {
        label: '无边框',
        value: 'borderless'
      }]
    }, {
      id: 'size',
      type: 'string',
      title: '大小',
      default: 'default',
      enum: [{
        label: '小',
        value: 'small'
      }, {
        label: '普通',
        value: 'default'
      }, {
        label: '大',
        value: 'large'
      }]
    }]
  },
  events: [{
    id: 'click',
    name: '点击',
    desc: '点击事件触发时',
    asProp: 'onClick'
  }],
  designerQuickEdit: [{
    trigger: {
      dblclick: true
    },
    content: ['prop:title', 'prop:icon']
  }]
};
export default ButtonComponentMeta;